<!-- @veltra/icons generated sha256:14fb8cd75115a1f9 gen:8 source:src/svg/normal/service.svg -->
<script setup lang="ts">
defineOptions({ name: 'Service' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M2.516 6.374a5.5 5.5 0 0 1 10.968 0 .5.5 0 0 1 .016.126v4a.5.5 0 0 1-.021.146A4.5 4.5 0 0 1 9 14.703h-.496A.506.506 0 0 1 8 14.199c0-.269.228-.496.504-.496H9A3.5 3.5 0 0 0 12.409 11H10.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1.93a4.501 4.501 0 0 0-8.86 0H5.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .016-.126M12.5 7H11v3h1.5zm-9 0v3H5V7z"
    />
  </svg>
</template>
